// extracted by mini-css-extract-plugin
export var buttonContainer = "_7z-1";
export var fontSizeSelect = "_7z-3";
export var formatSelect = "_7z-2";
export var formats = "_7z-4";
export var hidden = "_7z-5";
export var icon = "_7z-6";
export var select = "_7z-0";